import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { isBoolean, isString } from '../../lib/utils'
import styles from './card.scss'

const Card = (props) => {
  const { children, padding, className, style } = props

  const cardClass = classNames(className, styles.card, {
    [styles.padding]: isBoolean(padding) && padding
  })

  const cardStyle = {
    ...style
  }

  if (isString(padding) && padding) cardStyle.padding = padding

  return (
    <div className={cardClass} style={cardStyle}>
      {children}
    </div>
  )
}

Card.defaultProps = {
  children: null,
  padding: false,
  className: null,
  style: null
}

const { bool, element, oneOfType, shape, node, string } = PropTypes

Card.propTypes = {
  children: oneOfType([element, node, string]),
  padding: oneOfType([bool, string]),
  className: string,
  style: shape({})
}

export default Card
